import React from 'react';
import Svg, {Path} from 'react-native-svg';

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

const NovaAIVolumeIcon: React.FC<Props> = ({
  width = 36,
  height = 36,
  color = '#1C1C1C',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 36 36" fill="none">
      <Path
        d="M17.1665 11.9183C17.1663 11.8022 17.1318 11.6888 17.0672 11.5924C17.0027 11.4959 16.911 11.4207 16.8037 11.3763C16.6965 11.3319 16.5785 11.3203 16.4646 11.3429C16.3508 11.3655 16.2462 11.4213 16.164 11.5033L13.344 14.3225C13.2352 14.432 13.1057 14.5188 12.9631 14.5778C12.8205 14.6369 12.6675 14.6671 12.5132 14.6666H10.4998C10.2788 14.6666 10.0669 14.7544 9.91058 14.9107C9.7543 15.067 9.6665 15.279 9.6665 15.5V20.5C9.6665 20.721 9.7543 20.933 9.91058 21.0892C10.0669 21.2455 10.2788 21.3333 10.4998 21.3333H12.5132C12.6675 21.3329 12.8205 21.3631 12.9631 21.4221C13.1057 21.4812 13.2352 21.568 13.344 21.6775L16.1632 24.4975C16.2453 24.5798 16.3501 24.6359 16.4642 24.6586C16.5782 24.6814 16.6965 24.6697 16.8039 24.6252C16.9114 24.5807 17.0032 24.5052 17.0678 24.4085C17.1323 24.3117 17.1667 24.198 17.1665 24.0816V11.9183Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.3335 15.5C21.8744 16.2212 22.1668 17.0985 22.1668 18C22.1668 18.9015 21.8744 19.7788 21.3335 20.5"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.1367 23.3033C24.8332 22.6069 25.3856 21.7801 25.7625 20.8701C26.1395 19.9602 26.3335 18.9849 26.3335 18C26.3335 17.0151 26.1395 16.0398 25.7625 15.1298C25.3856 14.2199 24.8332 13.3931 24.1367 12.6967"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default NovaAIVolumeIcon;